export default __webpack_public_path__ + "static/media/fulcrum_animated.2c5ae0c9.gif";